module.exports = __webpack_public_path__ + "static/media/blue-t.412d2f83.svg";